import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBL: CultureInfo = {
  name: 'es-BL',
  displayName: 'español (San Bartolomé)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BL',
  parent: CultureInfoEs
};
